import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Row, Sortable, Tooltip } from "@workboard/wobo-ui";

const S = styled("span")``;

const Template = props => {
  const { t } = useTranslation();

  return (
    <Row>
      <Sortable {...props} property="teamName">
        {t('Team name')}
      </Sortable>
      <Sortable {...props} property="managerName">
        {t('Manager')}
      </Sortable>
      <Sortable {...props} property="level">
        {t('Level')}
      </Sortable>
      <Sortable {...props} property="memberCount">
        {t('Members')}
      </Sortable>
      <Sortable {...props} property="okrCount">
        {t("OKRs")}
      </Sortable>
      <Sortable {...props} property="okrProgressPercent">
        {t("OKRs Progress")}
      </Sortable>
      <Sortable {...props} property="krCount">
        {t("KRs")}
      </Sortable>
      <Sortable {...props} property="krPastDueCount">
        {t("KRs Past Due")}
      </Sortable>
      <Sortable {...props} property="krNeverUpdatedCount">
        {t("KRs Never Updated")}
      </Sortable>
      <Sortable {...props} property="okrExpiredCount">
        {/* Post-wave63
        <Tooltip
          content={`${t("OKRs")} from a prior period with zero days left. Typically they should be closed
            out by the team. This column is not affected by the selected ${t("OKR")} period.`}
          placement="top"
          arrow
        >
          <S>Expired {t("OKRs")}</S>
        </Tooltip>
        */}
        {t("Expired OKRs")}
      </Sortable>
      {/* Post-wave63
      <Sortable {...props} property="lastEngagement">
        <Tooltip
          content={`The date of the last ${t("key result")} update or comment on the team's ${t("OKRs")}.
            This column is not affected by the selected ${t("OKR")} period.`}
          placement="top"
          arrow
        >
          <S>Last Engagement</S>
        </Tooltip>
      </Sortable>
      */}
    </Row>
  );
};

export default styled(Template)`
  ${S} {
    font-weight: bold;
  }
`;
